import React, { useState, useEffect } from "react";
import "./ViewEmails.css";

const ViewEmails = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmails = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          "https://bombaydentalcompany.com/bombaydentalcompanyapi/get_emails.php",
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Emails fetched:", data);

        if (data.status === "success" && Array.isArray(data.data)) {
          setEmails(data.data);
        } else {
          throw new Error("Unexpected API response structure");
        }
      } catch (error) {
        console.error("Error fetching emails:", error);
        setError("Failed to fetch emails. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchEmails();
  }, []);

  if (loading) {
    return <div className="email-list-loading">Loading emails...</div>;
  }

  if (error) {
    return <div className="email-list-error">{error}</div>;
  }

  // Filter emails for bombaydentalcompany@gmail.com
  const filteredEmails = emails.filter(
    (email) => email?.email === "bombaydentalcompany@gmail.com"
  );

  return (
    <div className="email-list">
      <h1>Email List</h1>
      {filteredEmails.length === 0 ? (
        <p>No emails available.</p>
      ) : (
        <ul>
          {filteredEmails.map((email) => (
            <li
              key={email.id}
              className={`email-item ${
                email.is_checked ? "checked" : "unchecked"
              }`}
            >
              <div className="email-header">
                <strong>{email.subject}</strong> ({email.email})
              </div>
              <div className="email-body">
                {email.body.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {index < email.body.split("\n").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
              <div className="email-footer">
                Created At: {new Date(email.created_at).toLocaleString()}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ViewEmails;
